import { useAcceptMintRequest } from '@hooks/mutations/registry/mint/useAcceptMintRequest';
import { useAcceptMintRequest2Step } from '@hooks/mutations/registry/mint/useAcceptMintRequest2Step';
import { useCancelMintRequest } from '@hooks/mutations/registry/mint/useCancelMintRequest';
import { useCancelMintRequest2Step } from '@hooks/mutations/registry/mint/useCancelMintRequest2Step';
import { useRejectMintRequest } from '@hooks/mutations/registry/mint/useRejectMintRequest';
import { useRejectMintRequest2Step } from '@hooks/mutations/registry/mint/useRejectMintRequest2Step';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { MintRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { MintRequest as MintRequest3Step } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Mint';
import { ContractId } from '@daml/types';
import { RowNew } from '../../components/Table/types';

export const useGetMintChoices = (onSuccess?: () => void, selectedRow?: RowNew) => {
  const registrarService = useRegistrarService();

  // 2-Step hooks
  const acceptMintRequest = useAcceptMintRequest2Step();
  const rejectMintRequest = useRejectMintRequest2Step();
  const cancelMintRequest = useCancelMintRequest2Step();

  // 3-step hooks
  const acceptMintRequest3Step = useAcceptMintRequest();
  const rejectMintRequest3Step = useRejectMintRequest();
  const cancelMintRequest3Step = useCancelMintRequest();
  const contractId = selectedRow?.contractId;
  const registrarServiceCid = registrarService?.data?.contractId;

  const onAccept = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    if (selectedRow.isThreeStep) {
      if (!registrarServiceCid) {
        throw new Error('No registrar service');
      }
      await acceptMintRequest3Step({
        cid: registrarServiceCid,
        argument: { cid: contractId as ContractId<MintRequest3Step>, payload: {} },
      });
    } else {
      await acceptMintRequest({
        mintRequestId: contractId as ContractId<MintRequest>,
      });
    }
    onSuccess?.();
  };

  const onCancel = async () => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    if (selectedRow.isThreeStep) {
      await cancelMintRequest3Step({
        cid: contractId as ContractId<MintRequest3Step>,
        argument: {},
      });
    } else {
      await cancelMintRequest({
        mintRequestCid: contractId as ContractId<MintRequest>,
      });
    }
    onSuccess?.();
  };

  const onReject = async (reason: string) => {
    if (!contractId) {
      throw new Error('No row selected');
    }
    if (!registrarServiceCid) {
      throw new Error('No registrar service');
    }
    if (selectedRow.isThreeStep) {
      await rejectMintRequest3Step({
        cid: registrarServiceCid,
        argument: { cid: contractId as ContractId<MintRequest3Step>, payload: { reason } },
      });
    } else {
      await rejectMintRequest({
        mintRequestId: contractId as ContractId<MintRequest>,
        reason,
      });
    }
    onSuccess?.();
  };

  return {
    onAccept,
    onReject,
    onCancel,
  };
};
